<template>
    <div id="app">
        <transition name="main-page" mode="out-in">
        <!-- <vue-page-transition name="fade-in-right"> -->
            <router-view />
        <!-- </vue-page-transition> -->
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'app',
    computed: {
        ...mapGetters({
        pwa: 'pwa'
        })
    },
    created() {
        // if(this.$store.getters.isAuthenticated && window.location.pathname != '/instructiuni') {
        //     window.location.pathname = '/instructiuni';
        // }
        // Update activation ended - go to thankyou screen upon login
        if(this.$store.getters.isAuthenticated && window.location.pathname != '/info-activare') {
            window.location.pathname = '/info-activare';
        }
        /*
        window.addEventListener('beforeunload', () => {
            //I CAN ACCESS TO this VARIABLE
            console.log(this.anything);
        }, false)*/
    },
    mounted() {
        // window.onpopstate = function() {
        //     window.location.pathname = '/instructiuni';
        // };
        window.onpopstate = function() {
            window.location.pathname = '/info-activare';
        };
        
        this.$store.dispatch('getLocations')
        this.$store.dispatch('getQuestions')
        this.$store.dispatch('generateNewUuid')
    }
}

</script>

